import { ITranslationObject } from "@krea/shared/types/common";

import en from "./en.json";
import fi from "./fi.json";
import sv from "./sv.json";

export const bankIDTranslations: ITranslationObject<typeof en> = {
  en,
  sv,
  fi,
  namespace: "bankID",
};

export interface IBankIDTranslations {
  bankID: (typeof bankIDTranslations)["en"]["bankID"];
}
